/**
 * @description 本地缓存KEY加唯一锁
 * @param {String} lockKey  本地锁的key本身的名字 例如：ABC_PROCESS_LAST_KEY  （ABC_PROCESS_LAST_KEY：ABC_PROCESS_111_34233）
 * @param {String} currentKeyValue  当前缓存的key 例如 ： ABC_PROCESS_111_34233
 * @returns {String}  最后的真实KEY
 */
export default function (lockKey, currentKeyValue) {

  const localKeyValue = localStorage.getItem(lockKey)
  // 本地已经有缓存
  if (localKeyValue) {
    // 本地和当前的不一样，重置本地的lastKey值,移除上一个KEY，并返回当前key
    if (localKeyValue !== currentKeyValue) {
      localStorage.removeItem(localKeyValue)
      localStorage.setItem(lockKey, currentKeyValue)
      return currentKeyValue
    }
    // 本地和当前一样
    return localKeyValue
  } else {
    // 本地无缓存，则以当前为准,并设置
    localStorage.setItem(lockKey, currentKeyValue)
    return currentKeyValue
  }
}

